"use strict";

/* DOM ELEMENTS */
const body = document.querySelector('body');
const header = document.querySelector('header.nav-bar');
const navBtn = document.querySelectorAll('.nav-btn');
const navigation = document.querySelector('#navigation');
const navChevrons = document.querySelectorAll('#navigation .chevron');
const navLinks = document.querySelectorAll('#navigation li');

let filteredNavLinks = getLinksWithSubmenu(navLinks);

/* NAVIGATION */
function toggleNav() {
    if (!body.classList.contains('nav-open')) {
        header.classList.add('fade-out');
        setTimeout(() => {
            body.classList.add('nav-open');
        }, 300);
    } else {
        setTimeout(() => {
            filteredNavLinks.forEach((link) => {
                link.classList.remove('submenu-expanded');
            });
            body.classList.remove('nav-open');
        }, 200);

        setTimeout(() => {
            header.classList.remove('fade-out');
        }, 500);
    }
}

function getLinksWithSubmenu(nodeList) {
    return Array.from(nodeList).map((link) => {
        if (
            link.classList.contains('flexbox')
            || (window.innerWidth < 992 && link.hasAttribute('id'))
        ) {
            let result = null;
            link.childNodes.forEach((child) => {
                if (child.tagName === 'A') {
                    result = child;
                }
            });
            if (link.classList.contains('accordion') && result === null) {
                link.childNodes.forEach((child) => {
                    if (child.tagName === 'DIV'
                        && !child.classList.contains('accordion-content')
                    ) {
                        result = child;
                    }
                });
            }
            return result;
        }
    }).filter((link) => {
        if (link) {
            return link;
        }
    });
}

/* EVENT LISTENERS */

for (let i = 0; i < navBtn.length; i++) {
    navBtn[i].addEventListener('click', toggleNav);
}

navChevrons.forEach((element) => {
    element.addEventListener('click', (event) => {
        event.target.parentElement.classList.toggle('submenu-expanded');
    });
});

window.addEventListener('resize', () => {
    filteredNavLinks = getLinksWithSubmenu(navLinks);
});

filteredNavLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
        if (!event.target.parentElement.classList.contains('submenu-expanded')) {
            event.preventDefault();
            event.target.parentElement.classList.add('submenu-expanded');
        } else {
            if (event.target.tagName === 'DIV') {
                event.target.parentElement.classList.remove('submenu-expanded')
            }
        }
    });
});
